import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports
import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import withHistory from 'mixins/with-history';

function TabPanel() {
    this.attributes({
        panelSelector: '[data-tab-panel]',
        navSelector: '[data-tab-nav]',
        useHistory: false,
        activeTab: '[data-tab-nav][data-active]',
    });
    this.after('initialize', function() {
        this.on('click', { navSelector: this.activateTab });
        if (this.attr.useHistory) {
            this.updateHistory();
            this.handlePopState();
        }
    });
    this.activateTab = function(e, data) {
        const $el = $(data.el);
        const targetPanelName = $el.data('tab-nav');
        const newLocation = $el[0].href;
        e.preventDefault();

        if ($el.data('tab-disabled')) {
            return;
        }
        this.activate(targetPanelName);
        this.trigger('uiTabSelectionChanged', { href: newLocation });
    };

    this.activate = function(tabName) {
        this.deactivateTabAndPanel(tabName);
        this.activateTabAndPanel(tabName);
    };

    this.updateHistory = function() {
        this.on('uiTabSelectionChanged', function(e, data) {
            this.pushHistory(data.href);
        });
    };

    this.handlePopState = function() {
        let tabName;
        let pathName;
        let search;
        window.onpopstate = function() {
            pathName = window.location.pathname;
            search = window.location.search;
            tabName = $(`[data-tab-nav][href="${pathName}${search}"]`).data('tab-nav');
            if (!tabName) return null;
            return this.activate(tabName);
        }.bind(this);
    };

    this.deactivateTabAndPanel = function(tabName) {
        this.select('panelSelector')
            .not(`[data-tab-panel="${tabName}"]`)
            .removeAttr('data-active');
        this.select('navSelector')
            .not(`[data-tab-nav="${tabName}"]`)
            .removeAttr('data-active');
    };

    this.activateTabAndPanel = function(tabName) {
        this.$node.find(`[data-tab-panel="${tabName}"]`).attr('data-active', '');
        this.$node.find(`[data-tab-nav="${tabName}"]`).attr('data-active', '');
    };
}

export default defineComponent(TabPanel, withHistory);



// WEBPACK FOOTER //
// ./src/js/component_ui/tab-panel.js